(($)=>{
    "use strict";

	if ( $( '.page-template-template-spanish .latest-blog-posts__slider' ).length > 0 ) {
		const latestBlogPostsSlider = $( '.page-template-template-spanish .latest-blog-posts__slider' );
		const sliderControls = latestBlogPostsSlider.siblings( '.slick-controls' );
		const prev = sliderControls.find( '.slick-prev ');
		const next = sliderControls.find( '.slick-next ');
		latestBlogPostsSlider.slick( {
			slidesToShow: 3,
			slidesToScroll: 1,
			infinite: false,
			dots: false,
			arrows: true,
			autoplay: false,
			prevArrow: prev,
			nextArrow: next,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 1,
					},
				},
			],
			//init: sliderControls.removeClass( 'd-none' );
		} );
	}
	if ( $( '.page-template-template-spanish .section-parental_controls .row.platforms' ).length > 0 ) {
		const parentalControlSlider = $( '.page-template-template-spanish .section-parental_controls .row.platforms' );

		let sliderOn = false;

		function parentalControlSliderInit() {
			if ( $( window ).width() < 992 ) {
				if ( ! sliderOn ) {
					parentalControlSlider.slick( {
						slidesToShow: 3,
						slidesToScroll: 1,
						infinite: false,
						dots: false,
						arrows: true,
						autoplay: false,
						responsive: [
							{
								breakpoint: 992,
								settings: {
									slidesToShow: 2,
								},
							},
							{
								breakpoint: 576,
								settings: {
									slidesToShow: 1,
								},
							},
						],
					} );
					sliderOn = true;
				}
			} else if ( sliderOn ) {
				setTimeout( function() {
					parentalControlSlider.slick( 'unslick' );
				}, 700 ); // all animations should stop, otherwise this block disappears on resizing
				sliderOn = false;
			}
		}
		parentalControlSliderInit();
		setTimeout( function() {
			parentalControlSliderInit();
		}, 700 );
	
		$( window ).on( 'resize', function() {
			parentalControlSliderInit();
		} );
	}
})(jQuery);
